export default {
  // Set newsfeed timestamp
  newsfeedTimestamp(state) {
    state.newsfeedTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  // Set posts
  posts(state, payload) {
    state.posts = payload;
  },
};
